import React from 'react'
import { Alert } from '@sainsburys-tech/bolt'
import * as Styled from './WriteReviewSubmitted.styles'

const WriteReviewSubmitted = ({ submitResponse }) => {
  if (submitResponse.HasErrors) {
    return (
      <Styled.Wrapper>
        <Alert kind='error' isCloseable={false}>
          Sorry, we are having trouble submitting your review, please try again or check back later.
        </Alert>
      </Styled.Wrapper>
    )
  }
  return (
    <Styled.Wrapper>
      <Styled.Heading>Thank you for your review</Styled.Heading>
      <Styled.Message>
        Your review has been submitted. Please note that it may take up to 24 hours to appear.
      </Styled.Message>
      <Styled.Button
        kind='secondary'
        full
        onClick={() => {
          window.location.href = 'https://tuclothing.sainsburys.co.uk/'
        }}
      >
        Continue shopping
      </Styled.Button>
    </Styled.Wrapper>
  )
}

export default WriteReviewSubmitted
